export default __webpack_public_path__ + "static/media/flower.c3cbc890.jpg";